import { SelectionGedcomFile, SelectionGedcomSource, SelectionDateExact, SelectionSubmitterReference, SelectionAny } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionHeader extends SelectionWithNoteMixin(SelectionAny) {
    getGedcomFile() {
        return this.get("GEDC" /* Tag.Gedcom */, null, SelectionGedcomFile);
    }
    getCharacterEncoding() {
        return this.get("CHAR" /* Tag.Character */);
    }
    getSourceSystem() {
        return this.get("SOUR" /* Tag.Source */, null, SelectionGedcomSource);
    }
    getDestinationSystem() {
        return this.get("DEST" /* Tag.Destination */);
    }
    getFileCreationDate() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDateExact);
    }
    getLanguage() {
        return this.get("LANG" /* Tag.Language */);
    }
    getSubmitterReference() {
        return this.get("SUBM" /* Tag.Submitter */, null, SelectionSubmitterReference);
    }
    getFilename() {
        return this.get("FILE" /* Tag.File */);
    }
    getCopyright() {
        return this.get("COPR" /* Tag.Copyright */);
    }
}
//# sourceMappingURL=SelectionHeader.js.map